import React, {useContext} from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { _t, customStyle } from "../../../../../functions/Functions"
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import Select from "react-select";

const KdsHeader = ({
  name,
  apiEndpoint,
  refresh,
  orderReady,
  setReadyOrderCounter,
  setSearchedOrder,
  filterOrder,
  handleFilter
}) => {
  const { t } = useTranslation();
  const { authUserInfo } = useContext(UserContext);
  const {
    //kitchen dashboard
    getKitchenNewOrders,
    kithcenNewOrders,
    branchForSearch,
    branchForListSearch
  } = useContext(RestaurantContext);

  //search orders here
  const handleSearch = (e,branch = null) => {
    let searchInput = e ? e.target.value.toLowerCase() : "";
    if(branch){
      let searchedList = kithcenNewOrders &&
      kithcenNewOrders.filter((item) => {
        //token
        let lowerCaseItemToken = item.branch_id;
        return lowerCaseItemToken === branch.id;
      });
      setSearchedOrder((curr)=>({
        ...curr,
        list: searchedList,
        searched: true,
      }));
    }else if(searchInput?.length){
      let searchedList = kithcenNewOrders &&
        kithcenNewOrders.filter((item) => {
          //token
          let lowerCaseItemToken = item.token?.id.toLowerCase();

          return lowerCaseItemToken.includes(searchInput);
        });
      setSearchedOrder((curr)=>({
        ...curr,
        list: searchedList,
        searched: true,
      }));
    }else{
      setSearchedOrder((curr)=>({ ...curr, searched: false }));
    }
  };

  return (
    <>
      <div className="row gx-2 align-items-center">
        <div className={`${name === "Kitchen" ? "col-md-4" : "col-md-5"} t-mb-15 mb-md-0 col-sm-6`}>
          <ul className="t-list fk-breadcrumb">
            <li className="fk-breadcrumb__list">
              <span className="t-link fk-breadcrumb__link text-uppercase">
                <span className="mr-2">
                  <img
                    src="/assets/img/cooking.png"
                    alt="cooking"
                    className="img-fluid"
                    style={{ height: "40px", width: "40px" }}
                  />
                </span>
                <span className="mr-1">{_t(t(name))}</span>{" "}
                {_t(t("Dashboard"))}
              </span>
            </li>
          </ul>
        </div>
        {name === "Kitchen" && (
          <div className="col-md-1 col-sm-3 rounded">
            <NavLink
              to="/dashboard/kitchen/online"
              className="btn btn-secondary btn-block sm-text text-uppercase mb-2 mb-md-0 text-truncate rounded"
            >
              {_t(t("Online Odr."))}
            </NavLink>
          </div>
          )
        }
        <div className="col-md-1 rounded col-sm-3">
          <button
            type="button"
            onClick={() => {
              const promiseThen = new Promise((resolve, reject) => {
                setTimeout(() => {
                  resolve(getKitchenNewOrders(apiEndpoint));
                }, 100);
              });

              promiseThen
                .then(() => {
                  let newOrder = orderReady.current;
                  let refreshOrder = refresh.current;
                  if (newOrder < refreshOrder) {
                    let beep = document.getElementById("myAudioPhoneRing");
                    beep.play();
                  }
                  setReadyOrderCounter(refreshOrder);
                })
                .catch((err) => console.log(err));

              setSearchedOrder((curr)=>({
                ...curr,
                searched: false,
              }));
            }}
            className="btn btn-primary btn-block sm-text text-uppercase mb-2 mb-md-0 text-truncate rounded"
          >
            {_t(t("Refresh"))}
          </button>
        </div>
        <div className="col-md-2 rounded col-sm-6">
          {authUserInfo.details && (
            (authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager" && authUserInfo.details.user_type !== "waiter" ) ? (
              <Select
                options={branchForSearch && branchForSearch}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                onChange={(branch)=>handleSearch("",branch)}
                isClearable
                classNamePrefix="Branch"
                className="sm-text"
                maxMenuHeight="13rem"
                placeholder="Branch"
                styles={customStyle}
              />
            ) : (
              <div className="text-truncate text-primary text-right font-weight-md">
                {branchForListSearch[authUserInfo.details?.branch_id]?.name}
              </div>
            ))
          }
        </div>
        <div className="col-md-2 col-sm-6">
          <Select
            options={filterOrder.groups && filterOrder.groups}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.name}
            classNamePrefix="select"
            className="xsm-text mb-2 mb-md-0 "
            onChange={handleFilter}
            maxMenuHeight="200px"
            styles={customStyle}
            placeholder={_t(t("Filter by group")) + ".."}
          />
        </div>

        <div className="col-md-2 col-sm-3">
          <div className="input-group">
            <div className="form-file">
              <input
                type="text"
                className="form-control border-0 form-control--light-1 rounded-left"
                placeholder={_t(t("Search by token")) + ".."}
                onChange={(e)=>handleSearch(e)}
              />
            </div>
            <button className="btn btn-primary rounded-right" type="button">
              <i className="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

    </>
  );
};

export default KdsHeader;
